<template>
  <div class="page_wraper">
    <div v-if="loader" class="loader_out d-flex align-items-center justify-content-center">
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
      <!-- <p class="text-white">Loading</p> -->
    </div>
    <div class="welcome_msg">
      <p class="text-left custom-fontFamily">
        Hi <b>{{ getUserDetail && getUserDetail.username }},</b> Welcome to the
        YTeach Admin Portal
      </p>
    </div>
    <div class="row mt-4">
      <div class="col-lg-5">
        <div class="avg_lesson">
          <p class="text-left mb-0">Avg Lesson Rating</p>
          <span>{{
            getChartResponse && getChartResponse.avgLessonRating
              ? getChartResponse.avgLessonRating
              : '0'
          }}</span>
        </div>
      </div>
      <div class="col-lg-7 custom-datepicker justify-content-end">
        <button type="button" class="custom-month" v-bind:class="{
          active: this.type == 'week' ? this.isActive : false
        }" @click="filterData($event, 'week')">
          Week
        </button>
        <button type="button" class="custom-month" v-bind:class="{
          active: this.type == 'month' ? this.isActive : false
        }" @click="filterData($event, 'month')">
          Month
        </button>
        <button type="button" class="custom-month mr-0" v-bind:class="{
          active: this.type == 'custom' ? this.isActive : false
        }" @click="filterData($event, 'custom')">
          Custom
        </button>
        <date-picker v-if="type == 'custom'" v-model="dateSelected" type="date" placeholder="Select date" range
          :show-time-panel="showTimeRangePanel" :disabled-date="disableFutureDates" @close="handleRangeClose"
          id="custom-datepicker1">
        </date-picker>
      </div>
    </div>
    <div class="lesson_wraper">
      <div class="single_box">
        <div class="custom-paragraph-1">
          <p class="custom-heading">
            <b>{{
              getChartFilterResponse && getChartFilterResponse.totalLessons
                ? getChartFilterResponse.totalLessons
                : '0'
            }}</b>
          </p>
          <p class="custom-value">Total Lessons</p>
        </div>
      </div>
      <div class="single_box">
        <div class="custom-paragraph-1">
          <p class="custom-heading">
            <b>{{
              getChartResponse && getChartResponse.communityServiceHours
                ? getChartResponse.communityServiceHours
                : '0'
            }}</b>
          </p>
          <p class="custom-value">Community Service Hours</p>
        </div>
      </div>
      <div class="single_box">
        <div class="custom-paragraph-1">
          <p class="custom-heading">
            <b>{{
              getChartFilterResponse && getChartFilterResponse.messagesSent
                ? getChartFilterResponse.messagesSent
                : '0'
            }}</b>
          </p>
          <p class="custom-value">Messages Sent</p>
        </div>
      </div>
      <div class="single_box">
        <div class="custom-paragraph-1">
          <p class="custom-heading">
            <b>{{
              getChartFilterResponse && getChartFilterResponse.adminHoursSaved
                ? getChartFilterResponse.adminHoursSaved
                : '0'
            }}
            </b>
          </p>
          <p class="custom-value">Admin Hours Saved</p>
        </div>
      </div>
      <div class="single_box">
        <div class="custom-paragraph-1">
          <p class="custom-heading">
            <b>{{
              getChartResponse && getChartResponse.totalTutors
                ? getChartResponse.totalTutors
                : '0'
            }}</b>
          </p>
          <p class="custom-value">Total Tutors</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 custom-img text-left">
        <div class="admin_heading">
          <h2>Active Users On App</h2>
        </div>
        <canvas id="planet-line" height="249"></canvas>
      </div>
      <div class="col-lg-6 custom-img text-left">
        <div class="admin_heading">
          <h2>Completed Lessons</h2>
        </div>
        <canvas id="planet-chart" height="249"></canvas>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="mt-5 mb-2 custom-table">
          <table v-if="getChartResponse && getChartResponse.topTutors">
            <tr>
              <th colspan="3" class="py-2 text-center table-heading">
                Top Tutors
              </th>
            </tr>
            <tr v-if="
              getChartResponse &&
              getChartResponse.topTutors &&
              getChartResponse.topTutors.length > 0
            ">
              <th class="py-2 table-heading1">Name</th>
              <th class="py-2 table-heading1">School</th>
              <th class="py-2 table-heading1">Actions</th>
            </tr>
            <tr v-for="(item, i) in getChartResponse &&
              getChartResponse.topTutors" :key="i">
              <td class="py-2">{{ item.firstName }} {{ item.lastName }}</td>
              <td class="py-2">{{ item.school }}</td>
              <td class="text-center">
                <!-- <a href="#/students/" {{item.user class}}="btn btn-primary">View</a> -->
                <button class="btn btn-primary table-view-button" @click="redirectUserToDetailPage(item._id)">
                  View
                </button>
              </td>
            </tr>
            <tr v-if="
              getChartResponse &&
              getChartResponse.topTutors &&
              getChartResponse.topTutors.length == 0
            ">
              <td class="py-2 text-center">No Data Found</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="mt-5 mb-2 custom-table">
          <table>
            <tr>
              <th colspan="2" class="py-2 text-center table-heading">
                Top Requested Courses
              </th>
            </tr>
            <tr v-if="
              getChartResponse &&
              getChartResponse.topCourses &&
              getChartResponse.topCourses.length > 0
            ">
              <th class="py-2 table-heading1">Name</th>
            </tr>
            <tr v-for="(item, i) in getChartResponse.topCourses" :key="i">
              <td class="py-2">{{ item._id.name }}</td>
            </tr>

            <tr v-if="
              getChartResponse &&
              getChartResponse.topCourses &&
              getChartResponse.topCourses.length == 0
            ">
              <td class="py-2 text-center">No Data Found</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { Component } from 'vue-property-decorator'
// import {namespace} from 'vuex-class'
// import BaseList from '@/components/BaseList'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Chart from 'chart.js'
import * as moment from 'moment'
import { baseUrl } from '@/config'
// const appModule = namespace('app')

export default {
  //   @appModule.State('filterBySchool') stateFilterBySchool
  //   @appModule.State('schools') stateSchools
  //   @lessonsModule.State('statuses') stateStatuses

  components: { DatePicker },
  computed: {},

  data() {
    return {
      dateSelected: [],
      startDate: '',
      endDate: '',
      schoolId: !localStorage.getItem('schoolId')
        ? 'all'
        : localStorage.getItem('schoolId'),
      type: 'week',
      datePickerExist: false,
      showTimePanel: false,
      showTimeRangePanel: false,
      getChartFilterResponse: {},
      getChartResponse: {},
      getUserDetail: {},
      isActive: true,
      barChart: '',
      lineChart: '',
      loader: false
    }
  },

  methods: {
    //disable future dates
    disableFutureDates(date) {
      const today = new Date(); // Get current date
      today.setHours(0, 0, 0, 0); // Remove time part for comparison
      return date > today; // Disable dates after today
    },
    reloadPage: function () {
      this.loader = true
      let payload = {
        startDate: this.startDate,
        endDate: this.endDate,
        schoolId: localStorage.getItem('schoolId'),
        type: this.type
      }
      let that = this
      setTimeout(function () {
        // this.tableLoading = false
        payload.schoolId = localStorage.getItem('schoolId')
          ? localStorage.getItem('schoolId')
          : 'all'
        that.$http
          .post(`${baseUrl}dashboard/chart-filter`, payload)
          .then(response => {
            that.getChartFilterResponse = response.data.success
              ? response.data.result
              : null
            that.chartGraph(that.getChartFilterResponse)
            that.getDataByChart()
            this.loader = false
          })
      }, 500)
    },
    // isTableLoading() {
    //   return this.loader
    // },
    filterData(event, type) {
      if (type) {
        this.type = type
      }
      if (type == 'custom') {
        this.datePickerExist = true
        if (this.dateSelected && this.dateSelected.length > 0) {
          this.startDate = this.dateSelected[0]
            ? moment(this.dateSelected[0]).format('YYYY-MM-DD')
            : null
          this.endDate = this.dateSelected[1]
            ? moment(this.dateSelected[1]).format('YYYY-MM-DD')
            : null
        }
      }

      if (type !== 'custom') {
        let schoolId = localStorage.getItem('schoolId') || 'all'
        if (this.schoolId !== schoolId) {
          this.getDataByChart()
        }
        this.schoolId = schoolId ? schoolId : 'all'
        this.getDataByFilter()
      }
    },
    handleOpenChange() {
      this.showTimePanel = false
    },
    handleRangeClose() {
      this.showTimeRangePanel = false
      if (this.type == 'custom') {
        this.datePickerExist = true
        if (this.dateSelected && this.dateSelected.length > 0) {
          this.startDate = this.dateSelected[0]
            ? moment(this.dateSelected[0]).format('YYYY-MM-DD')
            : null
          this.endDate = this.dateSelected[1]
            ? moment(this.dateSelected[1]).format('YYYY-MM-DD')
            : null
        }
      }
      let schoolId = localStorage.getItem('schoolId') || 'all'
      if (this.schoolId !== schoolId) {
        this.getDataByChart()
      }
      this.schoolId = schoolId ? schoolId : 'all'
      this.getDataByFilter()
    },

    getDataByChart: function () {
      let payload = {
        schoolId: localStorage.getItem('schoolId')
          ? localStorage.getItem('schoolId')
          : 'all',
        type: this.type
      }
      let that = this
      setTimeout(function () {
        payload.schoolId = localStorage.getItem('schoolId')
          ? localStorage.getItem('schoolId')
          : 'all'
      }, 500)
      this.loader = true
      that.$http.post(`${baseUrl}dashboard/chart`, payload).then(response => {
        this.loader = false
        that.getChartResponse = []
        that.getChartResponse = response.data.success
          ? response.data.result
          : null
      })
    },
    getDataByFilter: function () {
      let payload = {
        startDate: this.type == 'custom' ? this.startDate : '',
        endDate: this.type == 'custom' ? this.endDate : '',
        schoolId: this.schoolId,
        type: this.type
      }
      this.loader = true
      this.$http
        .post(`${baseUrl}dashboard/chart-filter`, payload)
        .then(response => {
          this.loader = false
          this.getChartFilterResponse = []
          this.getChartFilterResponse = response.data.success
            ? response.data.result
            : null
          this.chartGraph(this.getChartFilterResponse)
        })
    },
    getUserProfile: function () {
      this.loader = true
      this.$http.get(`${baseUrl}users/detail`).then(response => {
        this.loader = false
        this.getUserDetail = response.data.success ? response.data.result : null
      })
    },
    chartGraph(response) {
      let chartBarData = []
      let charBarLabels = []
      let chartlineData = []
      let charlineLabels = []
      chartBarData = response.completedLessons.map(e => e.count)
      charBarLabels = response.completedLessons.map(e => e._id)
      chartlineData = response.activeUsersOnApp.map(e => e.count)
      charlineLabels = response.activeUsersOnApp.map(e => e._id)
      const ctx = document.getElementById('planet-chart')
      const ctxline = document.getElementById('planet-line')
      // Overwriting base render method with actual data.
      if (this.barChart) {
        this.barChart.destroy()
      }
      this.barChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: charBarLabels,
          datasets: [
            {
              label: '',
              data: chartBarData,
              backgroundColor: '#037bfeb0',
              borderColor: '#fff',
              borderWidth: 0,
              background: false
            }
          ]
        },
        options: {
          legend: {
            labels: {
              boxWidth: 0
            }
          },
          responsive: true,
          states: {
            hover: {
              filter: {
                type: 'none'
              }
            }
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  // beginAtZero: true,

                  beginAtZero: true,
                  callback: function (value) {
                    if (Number.isInteger(value)) {
                      return value
                    }
                  },
                  padding: 25
                }
              }
            ]
          }
        }
      })
      if (this.lineChart) {
        this.lineChart.destroy()
      }
      this.lineChart = new Chart(ctxline, {
        type: 'line',
        fill: false,
        data: {
          labels: charlineLabels,
          datasets: [
            {
              label: '',
              data: chartlineData,
              backgroundColor: 'rgba(51, 108, 251, 0.2)',
              borderColor: '#037bfe40',
              borderWidth: 3
            }
          ]
        },
        options: {
          elements: {
            line: {
              tension: 0 // disables bezier curves
            }
          },
          legend: {
            labels: {
              boxWidth: 0
            }
          },
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  callback: function (value) {
                    if (Number.isInteger(value)) {
                      return value
                    }
                  },
                  padding: 25
                }
              }
            ]
          }
        }
      })
    },
    redirectUserToDetailPage(userId) {
      window.location.replace('#/students/' + userId)
    }
  },
  destroyed: function () {
    window.removeEventListener('change', this.reloadPage)
  },
  mounted() {
    this.getDataByChart()
    this.getDataByFilter()
    this.getUserProfile()

    setTimeout(function () {
      this.username = localStorage.getItem('username')
    }, 1000)
  },
  updated() {
    window.addEventListener('change', this.reloadPage)
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page_wraper {
  padding: 0 20px;
  letter-spacing: 0.3px;
}

.custom-heading {
  font-size: 34px;
  color: #037bfe;
  line-height: 1.45;
  letter-spacing: 2px;
}

.custom-second-th {
  background: #0000000f;
}

.welcome_msg p {
  font-size: 1.5rem;
}

.custom-value {
  font-size: 13px;
  font-weight: 600;
}

.avg_lesson {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 4px;
  padding: 8px 10px;
  border: 1px solid #037bfeb0;
  box-shadow: 3px 3px 10px -5px rgba(0, 0, 0, 0.36);
}

.avg_lesson p {
  font-size: 13px;
  font-weight: 600;
  color: #037bfeb0;
}

.avg_lesson span {
  font-size: 19px;
  color: #037bfeb0;
  line-height: 1.45;
  font-weight: 600;
}

.table-heading1 {
  color: black;
  font-weight: 600;
  text-align: left;
  color: #000000a6;
  background: #3f475626;
}

.lesson_wraper {
  display: flex;
  flex-wrap: wrap;
  --space: 8px;
  margin: 50px calc(-1 * var(--space)) 40px;
}

.single_box {
  flex-basis: 20%;
  padding: var(--space);
}

.single_box .custom-paragraph-1 {
  height: 100%;
  border-radius: 4px;
  border: 1px solid #037bfeb0;
  padding: 15px 10px;
  box-shadow: 3px 3px 10px -5px rgba(0, 0, 0, 0.36);
}

.single_box .custom-paragraph-1 p {
  padding-bottom: 0px;
  margin-bottom: 0px;
  color: #037bfeb0;
}

.custom-datepicker {
  width: 100%;
  display: flex;
}

.custom-datepicker button {
  background: white;
  color: #0069d9;
  border-radius: 4px;
  border: 1px solid #0069d9;
}

.custom-datepicker button.active {
  background: #0069d9;
  color: white;
}

.custom-datepicker button:focus {
  outline: none;
}

.custom-datepicker button:hover {
  background: #0069d9;
  color: white;
}

.custom-img {
  padding-top: 20px;
}

.custom-img label {
  padding-top: 10px;
  color: #080808;
}

.custom-img img {
  width: 100%;
}

.custom-table {
  text-align: left;
}

.custom-table label {
  color: #080808;
}

.admin_heading h2 {
  font-size: 20px;
  font-weight: 700;
  color: #c0c8d7;
  margin-bottom: 0px;
  height: 35px;
  text-align: center;
  padding-top: 4px;
  border-color: #c0c8d7;
  background: #3f4756;
}

table {
  width: 100%;
  text-align: left;
  color: #2c3e50;
  border: 1px solid #0000001a;
}

table tr th {
  padding-left: 15px;
  background: #3f4756;
  color: #c0c8d7;
  border: 1px solid #0000001a;
}

table tr {
  border-bottom: 1px solid #dee2e6;
}

table tr td {
  padding-left: 15px;
  font-size: 16px;
}

.custom-month {
  min-width: 110px;
  margin-right: 2px;
  cursor: pointer;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.table-view-button {
  padding: 0px;
  height: 25px;
  width: 52px;
}

#planet-line {
  border: 1px solid #00000038;
}

#planet-chart {
  border: 1px solid #00000038;
}

@media screen and (max-width: 767px) {
  .custom-datepicker {
    margin-top: 14px;
  }

  .custom-month {
    min-width: 90px;
  }

  .lesson_wraper {
    display: block;
  }
}

@media screen and (max-width: 999px) {
  .custom-datepicker {
    margin-top: 14px;
  }
}

.loader_out {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  height: 100%;
  width: 100%;
  z-index: 9999;
  top: 0;
  left: 0;
  bottom: 0;
}

.lds-ripple p {
  position: absolute;
  bottom: -20px;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 100px;
  height: 100px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #037bfeb0;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }

  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

/* p {
  top: 50px;
  position: relative;
  text-align: center;
} */
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue